import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import { queryKeys } from '@/constant/common'
import { DeleteType } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import waterSourceApi from '@/api/config/waterSourceApi'
import useTranslation from '@/hooks/useTranslation'

async function deleteWaterSource(
  interfaceId: string,
  id: string,
): Promise<void> {
  await waterSourceApi.delete({ interfaceId, id })
}
const useDeleteWaterSource = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: DeleteType) => deleteWaterSource(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.waterSource])
        toast.success(t('DeletePipeSuccess'))
        closeModal()
      },
      onError: (error: AxiosError<any>) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )
}

export default useDeleteWaterSource
